import { jsx as _jsx } from "react/jsx-runtime";
import { Button, CircularProgress, useTheme, } from '@mui/material';
import { forwardRef } from 'react';
/**
 * A button that displays a loading spinner when the `loading` prop is set to `true`
 */
export const LoadingButton = forwardRef(({ loading = false, loadingText, defaultText, startIcon, variant = 'contained', ...rest }, ref) => {
    const theme = useTheme();
    return (
    // We can't use MUI's LoadingButton because it only allows a loading spinner
    // if there is an icon in the non-loading state.
    _jsx(Button, { ...rest, startIcon: loading ? (_jsx(CircularProgress, { "aria-label": "loading", size: theme.spacing(2), color: "inherit" })) : (startIcon), disabled: loading || rest.disabled, ref: ref, variant: variant, children: loading && loadingText ? loadingText : defaultText }));
});
